<template>
  <div class="col-12 q-mt-sm">
    <q-linear-progress size="xs" v-if="loadingTabela" indeterminate />
    <q-table
      dense
      :rows="listaTabela"
      no-data-label="Nenhum usuário encontrado."
      :columns="
        tipoTabela == 'usuarios' ? columnsUsuario : columnsUsuarioAfastado
      "
      :hide-bottom="listaTabela.length > 0"
      flat
      table-header-style="background-color: #d9effc"
      :rows-per-page-options="[0]"
    >
      <template #body-cell-nome="props">
        <q-td>
          {{ props.row.name }}
        </q-td>
      </template>
      <template #body-cell-email="props">
        <q-td>
          {{ props.row.email }}
        </q-td>
      </template>
      <template #body-cell-processoFuncao="props">
        <q-td>
          {{ props.row.function }}
        </q-td>
      </template>
      <template #body-cell-idUsuario="props">
        <q-td>
          {{ props.row.id }}
        </q-td>
      </template>
      <template #body-cell-matricula="props">
        <q-td>
          {{ props.row.sap }}
        </q-td>
      </template>
      <template #body-cell-detalhes="props">
        <q-td>
          <q-btn
            icon="sym_o_description"
            flat
            round
            color="blue"
            :to="{
              name: 'usun-detalhe-usuario',
              params: { id: props.row.id },
            }"
          />
        </q-td>
      </template>
      <template #body-cell-desligar="props">
        <q-td>
          <q-btn
            icon="sym_o_close"
            flat
            round
            color="red"
            @click="desligarFuncionario(props.row.id)"
          />
        </q-td>
      </template>
      <template #body-cell-afastar="props">
        <q-td>
          <q-btn
            icon="sym_o_person_remove"
            flat
            round
            color="orange"
            @click="alterarStatusFuncionario(props.row.id, 'Afastado')"
          />
        </q-td>
      </template>
      <template #body-cell-biometria="props">
        <q-td>
          <q-btn
            icon="sym_o_fingerprint"
            flat
            round
            :color="props.row.biometry ? 'green' : 'grey-5'"
          />
        </q-td>
      </template>
      <template #body-cell-termoAceite="props">
        <q-td>
          <q-btn
            icon="sym_o_book"
            flat
            round
            :color="props.row.biometry ? 'brand-1' : 'grey-5'"
            @click="detalhe(props.row.id)"
          />
        </q-td>
      </template>
    </q-table>
  </div>
</template>

<script setup>
import { useQuasar } from "quasar";
import { defineProps, ref, watch, defineEmits } from "vue";
import { useStore } from "vuex";

const columnsUsuario = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "email",
    label: "Email",
    align: "left",
  },
  {
    name: "processoFuncao",
    label: "Processo/Função",
    align: "left",
  },
  {
    name: "idUsuario",
    label: "ID Usuário",
    align: "left",
  },
  {
    name: "matricula",
    label: "Matrícula",
    align: "left",
  },
  {
    name: "detalhes",
    label: "Detalhes",
    align: "left",
  },
  {
    name: "desligar",
    label: "Desligar",
    align: "left",
  },
  {
    name: "afastar",
    label: "Afastar",
    align: "left",
  },
  {
    name: "biometria",
    label: "Biometria",
    align: "left",
  },
  {
    name: "termoAceite",
    label: "Termo de Aceite",
    align: "left",
  },
];

const columnsUsuarioAfastado = [
  {
    name: "nome",
    label: "Nome",
    align: "left",
  },
  {
    name: "email",
    label: "Email",
    align: "left",
  },
  {
    name: "processoFuncao",
    label: "Processo/Função",
    align: "left",
  },
  {
    name: "idUsuario",
    label: "Id Usuário",
    align: "left",
  },
  {
    name: "matricula",
    label: "Matrícula",
    align: "left",
  },
];

const props = defineProps({
  tipoTabela: {
    type: String,
  },
  listaTabela: {
    type: Array,
  },
  loading: {
    type: Boolean,
  },
});

const emit = defineEmits("atualizar");

const store = useStore();
const quasar = useQuasar();

const loadingTabela = ref(props.loading);

const desligarFuncionario = async (id) => {
  try {
    await store.dispatch("usuarioNovo/desligarFuncionario", {
      id,
    });

    quasar.notify({
      message: "Usuário Desligado com sucesso.",
      color: "positive",
      actions: [
        {
          label: "Fechar",
          color: "white",
          handler: () => {
            /* ... */
          },
        },
      ],
    });
    emit("atualizar");
  } catch (error) {
    if (error.response?.data?.erro?.mensagem) {
      quasar.notify({
        message: error.response?.data?.erro?.mensagem,
        color: "negative",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    }
  }
};

const alterarStatusFuncionario = async (id, status) => {
  try {
    await store.dispatch("usuarioNovo/alterarStatusFuncionario", {
      id,
      status,
    });

    if (status === "Afastado") {
      quasar.notify({
        message: "O usuário foi afastado.",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    } else {
      quasar.notify({
        message: "O usuário foi reativado.",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    }
    emit("atualizar");
  } catch (error) {
    if (error.response?.data?.erro?.mensagem) {
      quasar.notify({
        message: error.response?.data?.erro?.mensagem,
        color: "negative",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
    }
  }
};

watch(
  () => props.loading,
  () => {
    loadingTabela.value = props.loading;
  }
);
</script>
